// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionE_TheComp__ZBKB5","WinA":"SectionE_WinA__atA35"};